// extracted by mini-css-extract-plugin
export default {"successStoriesContainer":"SuccessStories_successStoriesContainer__EBecN","successStoriesInnerContainer":"SuccessStories_successStoriesInnerContainer__0FPj7"};